import React, { useState, useEffect } from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import './DailyStreak.css';
import { FaFire, FaCalendarAlt, FaTrophy } from 'react-icons/fa';

const DailyStreak = () => {
    const { isDarkMode } = useDarkMode();
    const [streak, setStreak] = useState(parseInt(localStorage.getItem('daily-streak') || '0'));
    const [lastVisit, setLastVisit] = useState(localStorage.getItem('last-visit') || '');
    const [showStreakMessage, setShowStreakMessage] = useState(false);

    useEffect(() => {
        const today = new Date().toDateString();
        
        if (lastVisit !== today) {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            const yesterdayString = yesterday.toDateString();
            
            if (lastVisit === yesterdayString) {
                // استمرار التحدي
                const newStreak = streak + 1;
                setStreak(newStreak);
                localStorage.setItem('daily-streak', newStreak.toString());
                setShowStreakMessage(true);
                setTimeout(() => setShowStreakMessage(false), 3000);
            } else if (lastVisit !== '') {
                // كسر التحدي
                setStreak(1);
                localStorage.setItem('daily-streak', '1');
            } else {
                // أول زيارة
                setStreak(1);
                localStorage.setItem('daily-streak', '1');
            }
            
            setLastVisit(today);
            localStorage.setItem('last-visit', today);
        }
    }, []);

    const getStreakMessage = () => {
        if (streak === 0) return 'ابدأ التحدي اليومي!';
        if (streak === 1) return 'أول يوم! استمر في التحدي';
        if (streak <= 3) return `أحسنت! ${streak} أيام متتالية`;
        if (streak <= 7) return `ممتاز! ${streak} أيام متتالية`;
        if (streak <= 14) return `رائع! ${streak} أيام متتالية`;
        return `أسطورة! ${streak} أيام متتالية`;
    };

    const getStreakIcon = () => {
        if (streak === 0) return <FaCalendarAlt />;
        if (streak <= 3) return <FaFire />;
        if (streak <= 7) return <FaTrophy />;
        return <FaFire />;
    };

    const getStreakColor = () => {
        if (streak === 0) return '#636e72';
        if (streak <= 3) return '#e17055';
        if (streak <= 7) return '#fdcb6e';
        return '#00b894';
    };

    return (
        <div className={`streak-container ${isDarkMode ? 'dark' : 'light'}`}>
            {showStreakMessage && (
                <div className="streak-notification">
                    <div className="streak-content">
                        <FaFire className="streak-icon" />
                        <span>🔥 مبروك! استمر في التحدي اليومي</span>
                    </div>
                </div>
            )}

            <div className="streak-card">
                <div className="streak-header">
                    <div className="streak-icon" style={{ color: getStreakColor() }}>
                        {getStreakIcon()}
                    </div>
                    <div className="streak-info">
                        <h3>التحدي اليومي</h3>
                        <p className="streak-count">{streak} يوم</p>
                        <p className="streak-message">{getStreakMessage()}</p>
                    </div>
                </div>

                <div className="streak-progress">
                    <div className="progress-bar">
                        <div 
                            className="progress-fill" 
                            style={{ 
                                width: `${Math.min((streak / 7) * 100, 100)}%`,
                                backgroundColor: getStreakColor()
                            }}
                        ></div>
                    </div>
                    <small>الهدف: 7 أيام متتالية</small>
                </div>

                <div className="streak-tips">
                    <h4>نصائح للحفاظ على التحدي:</h4>
                    <ul>
                        <li>استخدم الحاسبة يومياً</li>
                        <li>جرب العمليات العلمية المعقدة</li>
                        <li>شارك إنجازاتك مع الأصدقاء</li>
                        <li>ضع تذكير يومي على هاتفك</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default DailyStreak; 